import IdentificationError from './IdentificationError';
class PassportFileIsEmpty extends IdentificationError {
    constructor(options) {
        super('Passport file not has information', options);
    }
}
export default PassportFileIsEmpty;
